import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "step__four" }
const _hoisted_2 = { class: "text" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Выберите дату выдачи доверенности"),
  /*#__PURE__*/_createElementVNode("span", null, "Выберите или введите дату выдачи доверенности")
], -1)
const _hoisted_4 = { for: "title" }
const _hoisted_5 = { class: "date" }
const _hoisted_6 = ["max"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "text" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("p", null, "Выберите срок действия доверенности"),
    /*#__PURE__*/_createElementVNode("span", null, "Выберите или введите дату окончания действия")
  ])
], -1)
const _hoisted_8 = {
  class: "date",
  style: {"margin-top":"0px"}
}
const _hoisted_9 = ["min"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_switch = _resolveComponent("v-switch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("label", _hoisted_4, [
        _createVNode(_component_v_switch, {
          style: {"display":"flex","flex-direction":"column","justify-content":"flex-start"},
          color: "#2F80ED",
          modelValue: _ctx.document.proxy_re,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.document.proxy_re) = $event)),
          label: "Право передоверия"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _withDirectives(_createElementVNode("input", {
        class: "input",
        type: "date",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.document.proxy_date) = $event)),
        max: _ctx.proxy_end_date_comp
      }, null, 8, _hoisted_6), [
        [_vModelText, _ctx.document.proxy_date]
      ])
    ]),
    _hoisted_7,
    _createElementVNode("div", _hoisted_8, [
      _withDirectives(_createElementVNode("input", {
        class: "input",
        type: "date",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.document.proxy_end_date) = $event)),
        min: _ctx.proxy_date_comp
      }, null, 8, _hoisted_9), [
        [_vModelText, _ctx.document.proxy_end_date]
      ])
    ])
  ]))
}